
(function () {
  if (window.customPackControlsInitialized) return;
  window.customPackControlsInitialized = true;

  const fieldsetSelector = '.option-fieldset__choose-your-color';

  const quantities = {};
  const selectionOrder = [];

  let productData = null;
  let currentDuration = '';
  let previousVariantId = '';
  let updateScheduled = false;

  // -----------------------------------------
  // GET COLOR
  // -----------------------------------------

  function getColor(option) {
    const input = option.previousElementSibling;

    if (input && input.matches('input[type="radio"]')) {
      return input.value.trim();
    }

    return option.querySelector('.radio_swatch_label')
      ?.childNodes[0]?.textContent.trim() || '';
  }

  // -----------------------------------------
  // GET SELECTED DURATION
  // -----------------------------------------

  function getDurationFromTitle(title) {
    if (/60[\s-]*Day/i.test(title)) return '60-Day';
    if (/30[\s-]*Day/i.test(title)) return '30-Day';

    return '';
  }

  function getSelectedDuration() {
    // Prefer the actual duration option selected by the customer.
    const checkedInputs = document.querySelectorAll(
      'input[type="radio"]:checked'
    );

    for (const input of checkedInputs) {
      if (input.closest(fieldsetSelector)) continue;

      const duration = getDurationFromTitle(input.value);

      if (duration) return duration;
    }

    const selects = document.querySelectorAll('select');

    for (const select of selects) {
      if (select.id === 'main-original-variant') continue;

      const selectedText =
        select.options[select.selectedIndex]?.textContent || '';

      const duration = getDurationFromTitle(selectedText);

      if (duration) return duration;
    }

    // Fallback to the original variant select.
    const originalSelect = document.querySelector(
      '#main-original-variant'
    );

    if (originalSelect) {
      const title =
        originalSelect.options[originalSelect.selectedIndex]
          ?.textContent || '';

      const duration = getDurationFromTitle(title);

      if (duration) return duration;
    }

    return currentDuration;
  }


  // -----------------------------------------
  // disable the Add to Cart button when activePacks is zero
  // -----------------------------------------


function updateAddToCartButton() {
  const addToCartButton = document.querySelector(
    '.product-form__buttons button[name="add"]'
  );

  if (!addToCartButton) return;

  const activePacks = getActivePacks();

  // Calculate total quantity of all selected packs
  const totalQuantity = activePacks.reduce(
    (total, pack) => total + Number(pack.quantity || 0),
    0
  );

  const requiredQuantity = currentDuration === '60-Day' ? 2 : 1;

  const isValid = totalQuantity >= requiredQuantity;

  // Enable / Disable Add to Cart
  addToCartButton.disabled = !isValid;

  addToCartButton.classList.toggle(
    'pack-cart-disabled',
    !isValid
  );

  addToCartButton.setAttribute(
    'aria-disabled',
    String(!isValid)
  );

  // Error message above Add to Cart
  let errorBox = document.querySelector(
    '.pack-selection-error'
  );

  if (!errorBox) {
    errorBox = document.createElement('div');
    errorBox.className = 'pack-selection-error';

    addToCartButton.parentNode.insertBefore(
      errorBox,
      addToCartButton
    );
  }

  if (!isValid) {
    errorBox.textContent =
      currentDuration === '60-Day'
        ? 'Please select at least 2 packs to continue.'
        : 'Please select at least 1 pack to continue.';

    errorBox.style.display = 'block';
  } else {
    errorBox.textContent = '';
    errorBox.style.display = 'none';
  }

  console.log('Add to Cart Validation:', {
    duration: currentDuration,
    activePacks: activePacks.length,
    totalQuantity: totalQuantity,
    requiredQuantity: requiredQuantity,
    valid: isValid
  });
}



  // -----------------------------------------
  // MAX PACK LIMIT
  // -----------------------------------------

  function getMaxPackLimit() {
    return currentDuration === '60-Day' ? 2 : 1;
  }

  function getActivePacks() {
    return selectionOrder
      .filter(color => (quantities[color] || 0) > 0)
      .map(color => ({
        color: color,
        quantity: quantities[color]
      }));
  }

  function enforcePackLimit() {
    const maxLimit = getMaxPackLimit();

    while (getActivePacks().length > maxLimit) {
      const removedColor = selectionOrder.pop();

      if (removedColor) {
        quantities[removedColor] = 0;

        console.log(
          'Pack removed because of limit:',
          removedColor
        );
      }
    }
  }

  // -----------------------------------------
  // FIND VARIANT ID BY COLOR AND DURATION
  // -----------------------------------------

  function getVariantByColor(color, duration) {
    const select = document.querySelector(
      '#main-original-variant'
    );

    if (!select) return null;

    return Array.from(select.options).find(option => {
      const values = [
        option.dataset.option_1,
        option.dataset.option_2,
        option.dataset.option_3
      ].filter(Boolean);

      const colorMatch = values.some(
        value =>
          value.trim().toLowerCase() === color.toLowerCase()
      );

      const durationMatch = values.some(
        value =>
          getDurationFromTitle(value) === duration
      );

      return colorMatch && durationMatch;
    }) || null;
  }

  // -----------------------------------------
  // UPDATE CART INPUTS
  // -----------------------------------------


function updateCartInputs() {
  const firstQtyInput = document.querySelector(
    'input.quantity__input[name="quantity"]'
  );

  const firstIdInput = document.querySelector(
    'form[action*="/cart/add"] input[name="id"]'
  );

  const secondQtyInput = document.querySelector(
    '#choose-your-packs-variant-2-qty'
  );

  const secondIdInput = document.querySelector(
    '#choose-your-packs-variant-2'
  );

  const is60Day = currentDuration === '60-Day';

  const packs = getActivePacks();

  const firstPack = packs[0] || null;
  const secondPack = packs[1] || null;

  // Enable only when 60-Day AND second pack selected
  const enableSecondPack = is60Day && !!secondPack;

  if (secondQtyInput) {
    secondQtyInput.disabled = !enableSecondPack;
    secondQtyInput.value = '0';
  }

  if (secondIdInput) {
    secondIdInput.disabled = !enableSecondPack;
    secondIdInput.value = '';
  }

  // First pack quantity
  if (firstQtyInput) {
    firstQtyInput.value = firstPack
      ? String(firstPack.quantity)
      : '0';
  }

  // First pack variant ID
  if (firstPack) {
    const firstVariant = getVariantByColor(
      firstPack.color,
      currentDuration
    );

    if (firstVariant && firstIdInput) {
      firstIdInput.value = firstVariant.value;
    }
  }

  // Second pack variant ID and quantity
  if (enableSecondPack) {
    const secondVariant = getVariantByColor(
      secondPack.color,
      currentDuration
    );

    if (secondVariant) {
      if (secondIdInput) {
        secondIdInput.value = secondVariant.value;
      }

      if (secondQtyInput) {
        secondQtyInput.value = String(secondPack.quantity);
      }
    } else {
      // Keep inputs disabled if variant ID is unavailable
      if (secondIdInput) {
        secondIdInput.disabled = true;
      }

      if (secondQtyInput) {
        secondQtyInput.disabled = true;
      }

      console.warn(
        'Second pack variant not found:',
        secondPack.color
      );
    }
  }

  console.log('Cart Pack Inputs:', {
    duration: currentDuration,
    firstPack: firstPack,
    secondPack: secondPack,
    secondPackEnabled:
      secondIdInput ? !secondIdInput.disabled : false,
    secondVariantId: secondIdInput?.value || '',
    secondQuantity: secondQtyInput?.value || '0'
  });
}


  // -----------------------------------------
  // UPDATE PACK UI
  // -----------------------------------------

  function updateOption(option) {
    const color = getColor(option);
    const qty = quantities[color] || 0;

    const addBtn = option.querySelector('.pack-add-btn');
    const qtyBox = option.querySelector('.pack-quantity');
    const qtyValue = option.querySelector('.pack-qty-value');

    if (!addBtn || !qtyBox || !qtyValue) return;

    const maxReached =
      getActivePacks().length >= getMaxPackLimit();

    qtyValue.textContent = qty;

    addBtn.hidden = qty > 0;
    qtyBox.hidden = qty === 0;

    addBtn.disabled = qty === 0 && maxReached;

    option.classList.toggle('pack-selected', qty > 0);

    option.classList.toggle(
      'pack-disabled',
      qty === 0 && maxReached
    );
  }

  function updateAllOptions() {
    enforcePackLimit();

    document.querySelectorAll(
        fieldsetSelector + ' .type_product_variant'
    ).forEach(updateOption);

    updateCartInputs();

    // Enable or disable Add to Cart
    updateAddToCartButton();
  }

  // -----------------------------------------
  // QUANTITY BUTTON HANDLING
  // -----------------------------------------

  function getPackButton(target) {
    const button = target.closest(
      '.pack-add-btn, .pack-qty-plus, .pack-qty-minus'
    );

    if (!button) return null;

    const option = button.closest('.type_product_variant');

    if (!option || !option.closest(fieldsetSelector)) {
      return null;
    }

    return { button, option };
  }

  document.addEventListener('pointerdown', function (event) {
    if (getPackButton(event.target)) {
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('click', function (event) {
    const result = getPackButton(event.target);

    if (!result) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const { button, option } = result;

    const color = getColor(option);

    if (!color) return;

    let qty = quantities[color] || 0;

    const maxLimit = getMaxPackLimit();
    const activePacks = getActivePacks();

    // ADD NEW PACK
    if (button.classList.contains('pack-add-btn')) {
      if (qty === 0 && activePacks.length >= maxLimit) {
        console.log(
          'Maximum pack selection limit reached:',
          maxLimit
        );
        return;
      }

      qty = 1;
    }

    // INCREASE QUANTITY
    if (button.classList.contains('pack-qty-plus')) {
      qty++;
    }

    // DECREASE QUANTITY
    if (button.classList.contains('pack-qty-minus')) {
      qty = Math.max(0, qty - 1);
    }

    quantities[color] = qty;

    if (qty > 0 && !selectionOrder.includes(color)) {
      selectionOrder.push(color);
    }

    if (qty === 0) {
      const index = selectionOrder.indexOf(color);

      if (index !== -1) {
        selectionOrder.splice(index, 1);
      }
    }

    updateAllOptions();

    console.log('Selected Packs:', getActivePacks());

  }, true);

  // -----------------------------------------
  // LOAD SHOPIFY PRODUCT DATA
  // -----------------------------------------

  async function loadProductData() {
    if (productData) return productData;

    try {
      const response = await fetch(
        window.location.pathname + '.js'
      );

      if (!response.ok) return null;

      productData = await response.json();

      return productData;
    } catch (error) {
      console.error('Product loading error:', error);
      return null;
    }
  }

  // -----------------------------------------
  // VARIANT CHANGE
  // -----------------------------------------

  async function checkVariantChange() {
    const newDuration = getSelectedDuration();

    if (newDuration && newDuration !== currentDuration) {
      currentDuration = newDuration;

      console.log('Duration changed:', currentDuration);
      console.log('Max packs:', getMaxPackLimit());

      enforcePackLimit();
      updateAllOptions();
    }

    const variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (!variantInput || !variantInput.value) return;

    const variantId = String(variantInput.value);

    if (variantId === previousVariantId) return;

    const isInitial = !previousVariantId;

    previousVariantId = variantId;

    const product = await loadProductData();

    if (!product || previousVariantId !== variantId) return;

    const variant = product.variants.find(
      item => String(item.id) === variantId
    );

    if (!variant) return;

    console.log('Selected Variant:', variant.title);
    console.log('Variant ID:', variant.id);

    if (!isInitial) {
     // alert('Selected Variant: ' + variant.title);
    }
  }

  // -----------------------------------------
  // SHOPIFY VARIANT EVENTS
  // -----------------------------------------

  function scheduleUpdate() {
    if (updateScheduled) return;

    updateScheduled = true;

    requestAnimationFrame(function () {
      updateScheduled = false;

      checkVariantChange();
      updateAllOptions();
    });
  }

  document.addEventListener('change', function (event) {
    if (
      event.target.matches(
        'input[type="radio"], select, input[name="id"]'
      )
    ) {
      setTimeout(scheduleUpdate, 100);
    }
  });

  document.addEventListener(
    'variant:change',
    scheduleUpdate
  );

  // -----------------------------------------
  // SHOPIFY DYNAMIC RENDER SUPPORT
  // -----------------------------------------

  const observer = new MutationObserver(scheduleUpdate);

  // -----------------------------------------
  // INITIALIZE
  // -----------------------------------------

  async function init() {
    const variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (variantInput) {
      previousVariantId = String(variantInput.value);
    }

    currentDuration = getSelectedDuration() || '30-Day';

    await loadProductData();

    updateAllOptions();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value']
    });

    console.log('Pack selection initialized:', {
      duration: currentDuration,
      maxLimit: getMaxPackLimit()
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
